import { _ as __awaiter, a as __generator, b as __rest, c as __assign, d as __makeTemplateObject, e as __extends, f as __spreadArray } from './tslib.es6-11d02d8a.js';

/**
 * Cluster API
 * 0.0.2
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
var defaults = {
    baseUrl: "http://127.0.0.1:10000/api/1.0"
};
var servers = {
    server1: "http://127.0.0.1:10000/api/1.0",
    server2: "https://127.0.0.1:10000/api/1.0"
};
var _ = {
    fetch: function (url, req) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, baseUrl, headers, customFetch, init, href, res, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = __assign(__assign({}, defaults), req), baseUrl = _a.baseUrl, headers = _a.headers, customFetch = _a.fetch, init = __rest(_a, ["baseUrl", "headers", "fetch"]);
                        href = _.joinUrl(baseUrl, url);
                        return [4 /*yield*/, (customFetch || fetch)(href, __assign(__assign({}, init), { headers: _.stripUndefined(__assign(__assign({}, defaults.headers), headers)) }))];
                    case 1:
                        res = _d.sent();
                        if (!!res.ok) return [3 /*break*/, 3];
                        _b = HttpError.bind;
                        _c = [void 0, res.status];
                        return [4 /*yield*/, res.text()];
                    case 2: throw new (_b.apply(HttpError, _c.concat([_d.sent(), href])))();
                    case 3: return [2 /*return*/, res.text()];
                }
            });
        });
    },
    fetchJson: function (url, req) {
        if (req === void 0) { req = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _.fetch(url, __assign(__assign({}, req), { headers: __assign(__assign({}, req.headers), { Accept: "application/json" }) }))];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res && JSON.parse(res)];
                }
            });
        });
    },
    json: function (_a) {
        var body = _a.body, headers = _a.headers, req = __rest(_a, ["body", "headers"]);
        return __assign(__assign({}, req), { body: JSON.stringify(body), headers: __assign(__assign({}, headers), { "Content-Type": "application/json" }) });
    },
    form: function (_a) {
        var body = _a.body, headers = _a.headers, req = __rest(_a, ["body", "headers"]);
        return __assign(__assign({}, req), { body: QS.form(body), headers: __assign(__assign({}, headers), { "Content-Type": "application/x-www-form-urlencoded" }) });
    },
    multipart: function (_a) {
        var body = _a.body, req = __rest(_a, ["body"]);
        var data = new FormData();
        Object.entries(body).forEach(function (_a) {
            var name = _a[0], value = _a[1];
            data.append(name, value);
        });
        return __assign(__assign({}, req), { body: data });
    },
    /**
     * Deeply remove all properties with undefined values.
     */
    stripUndefined: function (obj) {
        return obj && JSON.parse(JSON.stringify(obj));
    },
    // Encode param names and values as URIComponent
    encodeReserved: [encodeURIComponent, encodeURIComponent],
    allowReserved: [encodeURIComponent, encodeURI],
    /**
     * Creates a tag-function to encode template strings with the given encoders.
     */
    encode: function (encoders, delimiter) {
        if (delimiter === void 0) { delimiter = ","; }
        var q = function (v, i) {
            var encoder = encoders[i % encoders.length];
            if (typeof v === "object") {
                if (Array.isArray(v)) {
                    return v.map(encoder).join(delimiter);
                }
                var flat = Object.entries(v).reduce(function (flat, entry) { return __spreadArray(__spreadArray([], flat), entry); }, []);
                return flat.map(encoder).join(delimiter);
            }
            return encoder(String(v));
        };
        return function (strings) {
            var values = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                values[_i - 1] = arguments[_i];
            }
            return strings.reduce(function (prev, s, i) {
                return "" + prev + s + q(values[i] || "", i);
            }, "");
        };
    },
    /**
     * Separate array values by the given delimiter.
     */
    delimited: function (delimiter) {
        if (delimiter === void 0) { delimiter = ","; }
        return function (params, encoders) {
            if (encoders === void 0) { encoders = _.encodeReserved; }
            return Object.entries(params)
                .filter(function (_a) {
                var value = _a[1];
                return value !== undefined;
            })
                .map(function (_a) {
                var name = _a[0], value = _a[1];
                return _.encode(encoders, delimiter)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "=", ""], ["", "=", ""])), name, value);
            })
                .join("&");
        };
    },
    joinUrl: function () {
        var parts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parts[_i] = arguments[_i];
        }
        return parts
            .filter(Boolean)
            .join("/")
            .replace(/([^:]\/)\/+/, "$1");
    }
};
/**
 * Functions to serialize query parameters in different styles.
 */
var QS = {
    /**
     * Join params using an ampersand and prepends a questionmark if not empty.
     */
    query: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var s = params.join("&");
        return s && "?" + s;
    },
    /**
     * Serializes nested objects according to the `deepObject` style specified in
     * https://github.com/OAI/OpenAPI-Specification/blob/master/versions/3.0.0.md#style-values
     */
    deep: function (params, _a) {
        var _b = _a === void 0 ? _.encodeReserved : _a, k = _b[0], v = _b[1];
        var qk = _.encode([function (s) { return s; }, k]);
        var qv = _.encode([function (s) { return s; }, v]);
        // don't add index to arrays
        // https://github.com/expressjs/body-parser/issues/289
        var visit = function (obj, prefix) {
            if (prefix === void 0) { prefix = ""; }
            return Object.entries(obj)
                .filter(function (_a) {
                var v = _a[1];
                return v !== undefined;
            })
                .map(function (_a) {
                var prop = _a[0], v = _a[1];
                var index = Array.isArray(obj) ? "" : prop;
                var key = prefix ? qk(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "[", "]"], ["", "[", "]"])), prefix, index) : prop;
                if (typeof v === "object") {
                    return visit(v, key);
                }
                return qv(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "=", ""], ["", "=", ""])), key, v);
            })
                .join("&");
        };
        return visit(params);
    },
    /**
     * Property values of type array or object generate separate parameters
     * for each value of the array, or key-value-pair of the map.
     * For other types of properties this property has no effect.
     * See https://github.com/OAI/OpenAPI-Specification/blob/master/versions/3.0.0.md#encoding-object
     */
    explode: function (params, encoders) {
        if (encoders === void 0) { encoders = _.encodeReserved; }
        var q = _.encode(encoders);
        return Object.entries(params)
            .filter(function (_a) {
            var value = _a[1];
            return value !== undefined;
        })
            .map(function (_a) {
            var name = _a[0], value = _a[1];
            if (Array.isArray(value)) {
                return value.map(function (v) { return q(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "=", ""], ["", "=", ""])), name, v); }).join("&");
            }
            if (typeof value === "object") {
                return QS.explode(value, encoders);
            }
            return q(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "=", ""], ["", "=", ""])), name, value);
        })
            .join("&");
    },
    form: _.delimited(),
    pipe: _.delimited("|"),
    space: _.delimited("%20")
};
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(status, message, url) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.url = url;
        return _this;
    }
    return HttpError;
}(Error));
/**
 * Create a new user
 */
function createUser(body, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user", _.json(__assign(__assign({}, opts), { method: "POST", body: body })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get multiple users
 */
function getMultipleUsers(_a, opts) {
    var _b = _a === void 0 ? {} : _a, pageNumber = _b.pageNumber, pageSize = _b.pageSize, ids = _b.ids;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user" + QS.query(QS.form({
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        ids: ids
                    })), __assign({}, opts))];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
}
/**
 * Authenticate a user
 */
function authUser(authRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/auth", _.json(__assign(__assign({}, opts), { method: "POST", body: authRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Authenticate a user using RBN website
 */
function auth(rbnAuthRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/rbn-auth", _.json(__assign(__assign({}, opts), { method: "POST", body: rbnAuthRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Authenticate a user using RBN website
 */
function authGuest(opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/guest-auth", _.json(__assign(__assign({}, opts), { method: "POST", body: {} })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Generates a password reset link for users who forgot their password
 */
function forgotPassword(forgotPasswordRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/forgot-password", _.json(__assign(__assign({}, opts), { method: "POST", body: forgotPasswordRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Takes a password reset token a resets a user's password
 */
function resetPassword(passwordResetRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/reset-password", _.json(__assign(__assign({}, opts), { method: "POST", body: passwordResetRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Returns a user object
 */
function getUser(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/" + id, __assign({}, opts))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Updates a user object
 */
function updateUser(id, body, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/" + id, _.json(__assign(__assign({}, opts), { method: "PUT", body: body })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Deletes a user object
 */
function deleteUser(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/" + id, __assign(__assign({}, opts), { method: "DELETE" }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Register a device ID for Apple Push Notifications
 */
function registerApnDevice(id, body, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/" + id + "/register-apn-device", _.json(__assign(__assign({}, opts), { method: "POST", body: body })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get a list of user cell favorites
 */
function getFavoriteCells(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/" + id + "/favorite-cells", __assign({}, opts))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Add/remove from the users favorite cell ids
 */
function updateFavoriteCells(id, cell, op, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/" + id + "/favorite-cells" + QS.query(QS.form({
                        cell: cell,
                        op: op
                    })), __assign(__assign({}, opts), { method: "PUT" }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Clear all user cell favorites
 */
function clearFavoriteCells(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/user/" + id + "/favorite-cells", __assign(__assign({}, opts), { method: "DELETE" }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get list of sources
 */
function getSources(opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/source", __assign({}, opts))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Create a new role
 */
function createRole(roleLongRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/role", _.json(__assign(__assign({}, opts), { method: "POST", body: roleLongRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get a list of all roles
 */
function getRoles(opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/role", __assign({}, opts))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get data for a role
 */
function getRole(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/role/" + id, __assign({}, opts))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Update data for a single role
 */
function updateRole(id, roleLongRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/role/" + id, _.json(__assign(__assign({}, opts), { method: "PUT", body: roleLongRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Deletes a role
 */
function deleteRole(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/role/" + id, __assign(__assign({}, opts), { method: "DELETE" }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Create a new board
 */
function createBoard(boardLongRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board", _.json(__assign(__assign({}, opts), { method: "POST", body: boardLongRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get a list of all boards a user has access to
 */
function getBoards(_a, opts) {
    var _b = _a === void 0 ? {} : _a, nameContains = _b.nameContains, showAll = _b.showAll;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board" + QS.query(QS.form({
                        nameContains: nameContains,
                        showAll: showAll
                    })), __assign({}, opts))];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
}
/**
 * Get data for a board
 */
function getBoard(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board/" + id, __assign({}, opts))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Update data for a single board
 */
function updateBoard(id, body, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board/" + id, _.json(__assign(__assign({}, opts), { method: "PUT", body: body })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Deletes a board
 */
function deleteBoard(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board/" + id, __assign(__assign({}, opts), { method: "DELETE" }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get a board layout
 */
function getBoardLayout(id, _a, opts) {
    var _b = _a === void 0 ? {} : _a, centroidId = _b.centroidId, familyTag = _b.familyTag, favoritesOnly = _b.favoritesOnly, todaysUpdatesOnly = _b.todaysUpdatesOnly, clientOptions = _b.clientOptions;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board/" + id + "/layout" + QS.query(QS.form({
                        centroidId: centroidId,
                        familyTag: familyTag,
                        favoritesOnly: favoritesOnly,
                        todaysUpdatesOnly: todaysUpdatesOnly,
                        clientOptions: clientOptions
                    })), __assign({}, opts))];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
}
/**
 * Add static layout for board
 */
function createStaticLayout(id, computedClusterLayout, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board/" + id + "/layout", _.json(__assign(__assign({}, opts), { method: "POST", body: computedClusterLayout })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Clear static layout for board
 */
function clearStaticLayout(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board/" + id + "/layout", __assign(__assign({}, opts), { method: "DELETE" }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Clear cached layouts for board
 */
function clearCache(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/board/" + id + "/clear-cache", __assign({}, opts))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Create a new cell
 */
function createCell(cellLongRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/cell", _.json(__assign(__assign({}, opts), { method: "POST", body: cellLongRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get multiple cells
 */
function getMultipleCells(_a, opts) {
    var _b = _a === void 0 ? {} : _a, pageNumber = _b.pageNumber, pageSize = _b.pageSize, ids = _b.ids, title = _b.title, withTags = _b.withTags, includeCellDetail = _b.includeCellDetail;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/cell" + QS.query(QS.form({
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        ids: ids,
                        title: title,
                        withTags: withTags,
                        includeCellDetail: includeCellDetail
                    })), __assign({}, opts))];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
}
/**
 * Get multiple public cells
 */
function getMultiplePublicCells(_a, opts) {
    var _b = _a === void 0 ? {} : _a, pageNumber = _b.pageNumber, pageSize = _b.pageSize, ids = _b.ids, title = _b.title, withTags = _b.withTags, includeCellDetail = _b.includeCellDetail;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/public-cell" + QS.query(QS.form({
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        ids: ids,
                        title: title,
                        withTags: withTags,
                        includeCellDetail: includeCellDetail
                    })), __assign({}, opts))];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
}
/**
 * Get data for a single cell
 */
function getCell(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/cell/" + id, __assign({}, opts))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Update data for a single cell
 */
function updateCell(id, cellLongRequest, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/cell/" + id, _.json(__assign(__assign({}, opts), { method: "PUT", body: cellLongRequest })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Deletes a cell
 */
function deleteCell(id, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/cell/" + id, __assign(__assign({}, opts), { method: "DELETE" }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get list of tags
 */
function getTagList(_a, opts) {
    var _b = _a === void 0 ? {} : _a, nameContains = _b.nameContains, nameStartsWith = _b.nameStartsWith;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/tag" + QS.query(QS.form({
                        nameContains: nameContains,
                        nameStartsWith: nameStartsWith
                    })), __assign({}, opts))];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
}
/**
 * Create an alert
 */
function createAlert(alertParams, opts) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/alert", _.json(__assign(__assign({}, opts), { method: "POST", body: alertParams })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Get a list of active alerts
 */
function getActiveAlerts(_a, opts) {
    var _b = _a === void 0 ? {} : _a, cellId = _b.cellId, boardId = _b.boardId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, _.fetchJson("/alert" + QS.query(QS.form({
                        cellId: cellId,
                        boardId: boardId
                    })), __assign({}, opts))];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var ClusterApi = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaults: defaults,
    servers: servers,
    _: _,
    QS: QS,
    HttpError: HttpError,
    createUser: createUser,
    getMultipleUsers: getMultipleUsers,
    authUser: authUser,
    auth: auth,
    authGuest: authGuest,
    forgotPassword: forgotPassword,
    resetPassword: resetPassword,
    getUser: getUser,
    updateUser: updateUser,
    deleteUser: deleteUser,
    registerApnDevice: registerApnDevice,
    getFavoriteCells: getFavoriteCells,
    updateFavoriteCells: updateFavoriteCells,
    clearFavoriteCells: clearFavoriteCells,
    getSources: getSources,
    createRole: createRole,
    getRoles: getRoles,
    getRole: getRole,
    updateRole: updateRole,
    deleteRole: deleteRole,
    createBoard: createBoard,
    getBoards: getBoards,
    getBoard: getBoard,
    updateBoard: updateBoard,
    deleteBoard: deleteBoard,
    getBoardLayout: getBoardLayout,
    createStaticLayout: createStaticLayout,
    clearStaticLayout: clearStaticLayout,
    clearCache: clearCache,
    createCell: createCell,
    getMultipleCells: getMultipleCells,
    getMultiplePublicCells: getMultiplePublicCells,
    getCell: getCell,
    updateCell: updateCell,
    deleteCell: deleteCell,
    getTagList: getTagList,
    createAlert: createAlert,
    getActiveAlerts: getActiveAlerts
});

export { deleteBoard as A, getBoardLayout as B, ClusterApi as C, createStaticLayout as D, clearStaticLayout as E, clearCache as F, createCell as G, HttpError as H, getMultipleCells as I, getMultiplePublicCells as J, getCell as K, updateCell as L, deleteCell as M, getTagList as N, createAlert as O, getActiveAlerts as P, QS as Q, _, authUser as a, auth as b, createUser as c, defaults as d, authGuest as e, forgotPassword as f, getMultipleUsers as g, getUser as h, deleteUser as i, registerApnDevice as j, getFavoriteCells as k, updateFavoriteCells as l, clearFavoriteCells as m, getSources as n, createRole as o, getRoles as p, getRole as q, resetPassword as r, servers as s, updateRole as t, updateUser as u, deleteRole as v, createBoard as w, getBoards as x, getBoard as y, updateBoard as z };
//# sourceMappingURL=ClusterApi-76f46b72.js.map
